import { assert } from '@deqo/foundation';
import { Trigger, TriggerHook } from './Trigger';

export class TriggerTree {

    private index = {} as Record<string, Trigger>;
    private tree = {} as Record<string, Record<string, Record<string, Set<Trigger>>>>;

    public add(tg: Trigger) {
        assert(!this.index[tg.id], `TriggerTree: ${tg.id} already registered.`);
        this.index[tg.id] = tg;
        for (const tp of tg.types) {
            // hookName, hookValue
            for (const [hn, hv] of Object.entries(tg.hooks)) {
                if (hv === true) {
                    this.insert(tp, hn, '*', tg);
                }
                else {
                    for (const hvi of hv) {
                        this.insert(tp, hn, hvi, tg);
                    }
                }
            }
        }
    }

    public remove(tg: Trigger) {
        delete this.index[tg.id];
        for (const tp of tg.types) {
            // hookName, hookValue
            for (const [hn, hv] of Object.entries(tg.hooks)) {
                if (hv === true) {
                    this.delete(tp, hn, '*', tg);
                }
                else {
                    for (const hvi of hv) {
                        this.delete(tp, hn, hvi, tg);
                    }
                }
            }
        }
    }

    public get(id: string) {
        return this.index[id];
    }

    public query(type: string, condition: TriggerHook, param: string) {
        const l1 = this.tree[type];
        if (!l1) return [];
        const l2 = l1[condition];
        if (!l2) return [];
        const l3 = l2[param];
        if (!l3) return [];
        return l3;
    }

    private insert(type: string, hook: string, param: string, tg: Trigger) {
        const l1 = this.tree[type] || (this.tree[type] = {});
        const l2 = l1[hook] || (l1[hook] = {});
        const l3 = l2[param] || (l2[param] = new Set());
        l3.add(tg);
    }

    private delete(type: string, hook: string, param: string, tg: Trigger) {
        const l1 = this.tree[type];
        if (!l1) return;
        const l2 = l1[hook];
        if (!l2) return;
        const l3 = l2[param];
        if (!l3) return;
        l3.delete(tg);
        if (l3.size === 0) delete l2[param];
        if (Object.keys(l2).length === 0) delete l1[hook];
        if (Object.keys(l1).length === 0) delete this.tree[type];
    }
}
